export const handleRadioGroupValue = (v)=>{
  if(v === 'true') return true
  if(v === 'false') return false
  else return undefined
}



// WEBPACK FOOTER //
// ./src/util/FormUtil.js